import { useCallback, useEffect, useState } from "react";

const SECTION_OBSERVER_OPTIONS = { rootMargin: "-45% 0px -50% 0px", threshold: 0 };

/** True once the window has scrolled past `threshold` pixels. */
export const useScrolledPast = (threshold = 12) => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > threshold);
  }, [threshold]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return scrolled;
};

/** Id of the section currently closest to the middle of the viewport. */
export const useActiveSection = (sectionIds) => {
  const [active, setActive] = useState("");
  const ids = Array.isArray(sectionIds) ? sectionIds.join(",") : "";

  useEffect(() => {
    const list = ids ? ids.split(",") : [];
    if (!list.length) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, SECTION_OBSERVER_OPTIONS);

    list.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [ids]);

  return active;
};
